export default (($) => {
    console.log('UNTUCKit : Module : Press : loaded');
    const $dom = {};
    const cacheDom = () => {
        $dom.loadMore = $('.js-press-load');
        $dom.articles = $('.js-press-block');
    };
    const loadArticles = (event) => {
        const $target = $(event.currentTarget);
        $dom.articles.removeClass('is-disabled');
        $target.addClass('is-disabled');
    };
    const bindUIActions = () => {
        $dom.loadMore.on('click', loadArticles);
    };
    const init = () => {
        console.log('UNTUCKit : Module : Press : init');
        cacheDom();
        bindUIActions();
    };
    return { init };
})($);
